"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Subject_1 = require("rxjs/Subject");
var http_service_1 = require("./http.service");
var accessory_local_1 = require("../model/accessory-local");
var find_http_error_1 = require("../error/find-http-error");
var store_1 = require("@angular-redux/store");
var AccessoryLocalService = /** @class */ (function () {
    function AccessoryLocalService(_httpService, ngRedux) {
        this._httpService = _httpService;
        this.ngRedux = ngRedux;
        this.FIND_LOCALS = AccessoryLocalService.ACCESSORY_LOCAL_ENDPOINT + "/findList";
        this.FIND_BY_NAME = AccessoryLocalService.ACCESSORY_LOCAL_ENDPOINT + "/findByName";
        this.FIND_BY_NAME_CONTAINS = AccessoryLocalService.ACCESSORY_LOCAL_ENDPOINT + "/findByNameContains";
        this.FIND_BY_FILTER = AccessoryLocalService.ACCESSORY_LOCAL_ENDPOINT + "/findByFilter";
        this.findSubject = new Subject_1.Subject();
        this.find$ = this.findSubject.asObservable();
        this.findLocalToMoveSubject = new Subject_1.Subject();
        this.findLocalToMove$ = this.findLocalToMoveSubject.asObservable();
        this.errorSubject = new Subject_1.Subject();
        this.error$ = this.errorSubject.asObservable();
    }
    AccessoryLocalService.prototype.findByNameContains = function (name, pageNumber, pageSize) {
        this.subscribeToFindList(this._httpService.get(this.FIND_BY_NAME_CONTAINS + "/" + name + "?pageNumber=" + pageNumber + "&pageSize=" + pageSize, Array, find_http_error_1.FindHttpError));
    };
    AccessoryLocalService.prototype.findLocals = function (pageNumber, pageSize) {
        this.subscribeToFindList(this._httpService.get(this.FIND_LOCALS + "?pageNumber=" + pageNumber + "&pageSize=" + pageSize, Array, find_http_error_1.FindHttpError));
    };
    AccessoryLocalService.prototype.findByName = function (name, localType) {
        this.subscribeToFindList(this._httpService.get(this.FIND_BY_NAME + "/" + name + "?localType=" + localType, accessory_local_1.AccessoryLocal, find_http_error_1.FindHttpError));
    };
    AccessoryLocalService.prototype.findByNameIgnoreLocal = function (name, pageNumber, pageSize, ignoredId, localType) {
        var _this = this;
        this._httpService.get(this.FIND_BY_NAME_CONTAINS + "/" + name + "?pageNumber=" + pageNumber + "&pageSize=" + pageSize, Array, find_http_error_1.FindHttpError)
            .subscribe(function (locals) { return _this.findLocalToMoveSubject.next(locals); }, function (error) { return _this.errorSubject.next(error); });
    };
    AccessoryLocalService.prototype.subscribeToFindList = function (observable) {
        var _this = this;
        observable
            .subscribe(function (locals) { return _this.findSubject.next(locals); }, function (error) { return _this.errorSubject.next(error); });
    };
    AccessoryLocalService.ctorParameters = function () { return [{ type: http_service_1.HttpService }, { type: store_1.NgRedux }]; };
    AccessoryLocalService.ACCESSORY_LOCAL_ENDPOINT = '/accessoryLocal';
    return AccessoryLocalService;
}());
exports.AccessoryLocalService = AccessoryLocalService;
//# sourceMappingURL=accessory-local.service.js.map


// WEBPACK FOOTER //
// accessory-local.service.js